module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/iphone6_splash-cc85227f3f4dc7c959fee93e9b8da217.png";